import { Translations } from './fr';

export const ja: Translations = {
  nav: {
    home: "ホーム",
    primeEvolution: "エボリューション",
    pulse: "パルス",
    sparkle: "スパークル",
    agents: "エージェント",
    partners: "パートナー",
    contact: "お問い合わせ",
    recruitAgent: "エージェントを採用",
  },
  hero: {
    title: "私たちの",
    titleHighlight: "AIエージェント",
    titleEnd: "でチームを強化",
    subtitle: "24時間年中無休で利用可能な仮想コラボレーター。ビジネスプロセスに精通し、生産性の変革を実現します。",
    cta: "AIエージェントを採用",
    discover: "プライムエボリューションを発見",
  },
  trust: {
    available: "24時間対応",
    secure: "100%安全",
    agents: "認定エージェント",
    support: "専任サポート",
  },
  primeEvolution: {
    badge: "フラッグシップソリューション",
    title: "プライムエボリューション",
    subtitle: "企業にAIを統合するための完全なサポートプログラム",
    description: "プライムエボリューションは、監査、トレーニング、カスタムAIエージェントの導入を組み合わせた包括的アプローチです。",
    features: {
      audit: { title: "戦略的監査", description: "自動化の機会を特定するためのプロセスの詳細分析。" },
      training: { title: "チームトレーニング", description: "AIとの効果的な協力のためのカスタマイズされたトレーニングプログラム。" },
      deployment: { title: "カスタム導入", description: "既存ツールと統合されたパーソナライズされたAIエージェント。" },
      support: { title: "継続的サポート", description: "専任サポートと継続的な最適化。" },
    },
    cta: "プライムエボリューションを開始",
    stats: { productivity: "平均生産性向上", roi: "投資収益率", satisfaction: "顧客満足度" },
  },
  pulse: {
    badge: "インテリジェント自動化",
    title: "VEECTORIAパルス",
    subtitle: "ビジネスのリズムに合わせた自動化",
    description: "パルスは、ワークフローをリアルタイムで接続・調整するインテリジェント自動化プラットフォームです。",
    features: {
      connect: { title: "接続", description: "200以上のプロフェッショナルツールとのネイティブ統合。" },
      orchestrate: { title: "調整", description: "自動的に適応するインテリジェントワークフロー。" },
      optimize: { title: "最適化", description: "プロセス改善のためのリアルタイム分析と推奨。" },
    },
    cta: "パルスを発見",
  },
  advantages: {
    badge: "選ばれる理由",
    title: "VEECTORIAのメリット",
    subtitle: "人間の専門知識とAIのパワーを組み合わせたユニークなアプローチ",
    items: {
      expertise: { title: "認められた専門性", description: "デジタル変革とAIにおける10年以上の経験。" },
      custom: { title: "カスタムソリューション", description: "各エージェントはプロセスに特化してトレーニング。" },
      security: { title: "最高のセキュリティ", description: "ヨーロッパでデータをホスト、GDPR準拠を保証。" },
      roi: { title: "保証されたROI", description: "測定可能な指標による結果へのコミットメント。" },
      support: { title: "24時間サポート", description: "いつでも利用可能な専任チーム。" },
      evolution: { title: "継続的進化", description: "機械学習によりエージェントが常に改善。" },
    },
  },
  sparkle: {
    badge: "インテリジェント・デジタル化",
    title: "Sparkle",
    subtitle: "AI搭載のTagPDF v7",
    description: "インテリジェントデジタル化ソリューションで、紙の文書を利用可能なデータに変換します。自動認識、データ抽出、インテリジェント分類。",
    features: {
      scan: {
        title: "高度なデジタル化",
        description: "あらゆる文書タイプに対応する高精度OCR。",
      },
      ai: {
        title: "統合AI",
        description: "重要データの自動分類と抽出。",
      },
      speed: {
        title: "超高速処理",
        description: "数千ページを数分で処理。",
      },
      accuracy: {
        title: "最高精度",
        description: "認識率99%以上。",
      },
    },
    cta: "Sparkleを見る",
    ctaFulltext: "フルテキスト索引",
    ctaFulltextDesc: "すべてのドキュメントを瞬時に検索。",
    ctaScan: "超高速スキャン → フォルダ",
    ctaScanDesc: "あっという間にスキャン＆整理。",
  },
  testimonials: {
    badge: "お客様の声",
    title: "信頼をいただいています",
    subtitle: "VEECTORIAでビジネスを変革したお客様の声",
    items: [
      { quote: "VEECTORIAのおかげで、管理業務を70%削減しました。", metric: "-70%", metricLabel: "管理時間", name: "イザベル G.", role: "事務部長" },
      { quote: "商用AIエージェントがリード獲得を変革。適格なアポイント40%増加。", metric: "+40%", metricLabel: "適格アポイント", name: "マルク D.", role: "営業部長" },
      { quote: "ドキュメントソリューションでファイル管理の貴重な時間を節約。", metric: "5x", metricLabel: "高速化", name: "ソフィー M.", role: "マネージャー" },
    ],
  },
  faq: {
    badge: "よくある質問",
    title: "VEECTORIAについて",
    subtitle: "よくある質問への回答",
    items: {
      q1: { question: "VEECTORIA AIエージェントとは？", answer: "特定のビジネスプロセスでトレーニングされたインテリジェントな仮想コラボレーター。" },
      q2: { question: "導入にはどのくらい時間がかかりますか？", answer: "標準導入は2〜4週間、複雑な要件では6〜8週間。" },
      q3: { question: "データは安全ですか？", answer: "もちろんです。すべてのデータはヨーロッパの認定サーバーでホスト、GDPR100%準拠。" },
      q4: { question: "期待される投資収益率は？", answer: "お客様は平均40%の生産性向上と3ヶ月以内のプラスROIを実現。" },
      q5: { question: "統合はどのように機能しますか？", answer: "VEECTORIAは200以上のプロフェッショナルツールとネイティブ統合。" },
    },
  },
  contact: {
    badge: "お問い合わせ",
    title: "ビジネスを変革する準備はできましたか？",
    subtitle: "ニーズについてお話しし、VEECTORIAがどのようにサポートできるかをご確認ください",
    form: {
      name: "お名前",
      email: "ビジネスメール",
      company: "会社名",
      phone: "電話番号",
      message: "メッセージ",
      submit: "送信",
      sending: "送信中...",
      success: "メッセージが正常に送信されました！",
      error: "送信エラー。もう一度お試しください。",
    },
    info: { title: "連絡先情報", email: "メール", phone: "電話", address: "住所" },
  },
  cta: {
    title: "行動を起こす準備はできましたか？",
    subtitle: "VEECTORIAで生産性を変革した企業に参加しましょう",
    button: "AIエージェントを採用",
  },
  footer: {
    description: "ビジネスを変革するための人工知能ソリューション。",
    navigation: "ナビゲーション",
    legal: "法的通知",
    privacy: "プライバシーポリシー",
    terms: "利用規約",
    cookies: "Cookie設定",
    rights: "全著作権所有。",
  },
  agents: {
    badge: "チーム",
    title: "AIエージェント",
    subtitle: "チームに参加する準備ができた仮想コラボレーターをご覧ください",
  },

  // AI Agents Showcase
  agentsShowcase: {
    badge: "企業に寄り添うAIの卓越性",
    title: "AIエージェントが日常業務を変革",
    description: "眠らず、常に学び続け、ビジネスプロセスに完璧に適応するバーチャルチームを想像してください。当社のAIエージェントは、あなたの能力を拡張し、繰り返し作業から人材を解放し、生産性を新たな高みへと導きます。",
    imageAlt: "VEECTORIA AIエージェントチーム",
    cta: "エージェントを発見する",
    benefits: {
      availability: "24時間365日対応",
      productivity: "生産性10倍",
      performance: "最適なパフォーマンス",
      collaboration: "シームレスな協力",
    },
  },
  cookies: {
    title: "Cookie管理",
    message: "当サイトでは、お客様の体験を向上させ、トラフィックを分析し、コンテンツをパーソナライズするためにCookieを使用しています。",
    accept: "すべて受け入れる",
    decline: "拒否",
    settings: "カスタマイズ",
    settingsTitle: "Cookie設定",
    settingsDescription: "Cookieの設定を管理してください。必須Cookieはサイトの機能に必要であり、無効にすることはできません。",
    saveChoices: "選択を保存",
    rejectAll: "すべて拒否",
    alwaysActive: "常にアクティブ",
    categories: {
      essential: { name: "必須Cookie", description: "これらのCookieはサイトの機能に必要であり、無効にすることはできません。" },
      analytics: { name: "分析Cookie", description: "これらのCookieにより、サイトのオーディエンスを測定し、ブラウジング行動を分析できます。" },
      marketing: { name: "マーケティングCookie", description: "これらのCookieは、パーソナライズされた広告を提供するために使用されます。" },
      preferences: { name: "設定Cookie", description: "これらのCookieは、お客様の設定（言語、テーマ、地域）を記憶します。" },
    },
  },

  // Partners Section
  partners: {
    badge: "パートナープログラム",
    title: "一緒に構築しましょう",
    description: "リセラー、ディストリビューター、ソフトウェアエディター、または卸売業者ですか？VEECTORIAは、最先端の人工知能ソリューションで新しい市場を征服するための優先技術パートナーになります。",
    valueProposition: "お客様のクライアント向けに完全でカスタマイズされたプロフェッショナルソリューションを設計・開発し、大量商業化戦略の実装をサポートします。魅力的なマージン、専任技術サポート、マーケティング支援：成功のためのすべての要素。",
    types: {
      resellers: { title: "リセラー", description: "当社のAIソリューションをカタログに統合し、差別化されたパッケージを提供。" },
      distributors: { title: "ディストリビューター", description: "お客様の地域で当社の技術を大規模に展開。" },
      editors: { title: "ソフトウェアエディター", description: "当社のAIでソフトウェアを強化し、比類のない付加価値を創出。" },
      wholesalers: { title: "卸売業者", description: "ネットワーク経由の大量配布に対する優遇料金にアクセス。" },
    },
    benefits: {
      title: "パートナー特典",
      whiteLabel: "ホワイトラベルソリューション",
      support: "専任技術サポート",
      scalability: "無制限のスケーラビリティ",
    },
    cta: "パートナーになる",
    ctaSubtext: "独占パートナープログラムについてお問い合わせください",
  },

  legal: {
    lastUpdate: "最終更新：2026年1月",
    mentions: {
      title: "法的通知",
      sections: {
        editor: { title: "1. サイト運営者", intro: "このサイトは以下によって運営されています：", companyName: "会社名", legalForm: "法的形態", capital: "資本金", address: "本社所在地", siren: "SIREN", siret: "SIRET", rcs: "RCS", tva: "VAT番号", naf: "NAFコード" },
        publication: { title: "2. 発行責任者", intro: "発行は以下によって管理されています：", since: "以来" },
        contact: { title: "3. 連絡先", phone: "電話", email: "メール" },
        hosting: { title: "4. ホスティング", intro: "サイトは以下によってホストされています：", name: "名前", address: "住所" },
        intellectual: { title: "5. 知的財産", content1: "このサイト全体は、著作権および知的財産に関するフランスおよび国際法の対象となります。", content2: "このサイトの全部または一部の複製は、以下からの明示的な許可なしに厳しく禁じられています" },
        liability: { title: "6. 責任の制限", content: "このサイトの情報は可能な限り正確です。{company}は、このサイトの使用から生じる直接的または間接的な損害について責任を負いません。" },
        law: { title: "7. 適用法", content: "このサイトはフランス法に準拠します。紛争が生じた場合、フランスの裁判所が専属管轄権を有します。" },
      },
    },
    privacy: {
      title: "プライバシーポリシー",
      sections: {
        intro: { title: "1. はじめに", content: "{company}は、ウェブサイトユーザーのプライバシーを保護することを約束します。このポリシーは、GDPRに従って個人データを収集、使用、保護する方法を説明します。" },
        controller: { title: "2. データ管理者", company: "会社", address: "住所", email: "メール" },
        data: { title: "3. 収集するデータ", intro: "以下のデータを収集します：", items: ["識別データ：氏名、メール、電話", "職業データ：会社、役職", "ナビゲーションデータ：IPアドレス、Cookie、訪問ページ", "通信データ：フォームからのメッセージ"] },
        purposes: { title: "4. 処理目的", intro: "データは以下の目的で収集されます：", items: ["お問い合わせへの対応", "AIサービスの提供", "サイトの改善", "商業通信の送信（同意がある場合）", "法的義務の遵守"] },
        basis: { title: "5. 法的根拠", intro: "処理は以下に基づいています：", items: ["明示的な同意", "契約の履行", "正当な利益", "法的義務"] },
        retention: { title: "6. 保持期間", content: "データは必要な期間、最後の連絡から最大3年間保持されます。" },
        rights: { title: "7. あなたの権利", intro: "GDPRに従い、以下の権利があります：", access: "アクセス権", accessDesc: "データのコピーを取得", rectification: "訂正権", rectificationDesc: "不正確なデータを修正", erasure: "消去権", erasureDesc: "データの削除を要求", restriction: "制限権", restrictionDesc: "処理を制限", portability: "ポータビリティ権", portabilityDesc: "構造化されたフォーマットでデータを受信", objection: "異議権", objectionDesc: "処理に異議を申し立て", contact: "これらの権利を行使するには、お問い合わせください：" },
        security: { title: "8. セキュリティ", content: "データを保護するための適切な技術的および組織的措置を実施しています。" },
        complaint: { title: "9. 苦情", content: "CNILに苦情を申し立てることができます：www.cnil.fr" },
      },
    },
    cgv: {
      title: "利用規約",
      sections: {
        object: { title: "1. 目的", content: "この利用規約は、AIサービス、ソフトウェア開発、ビジネスソリューションに関する{company}とクライアント間の契約関係を規定します。" },
        provider: { title: "2. プロバイダー", company: "会社", siret: "SIRET", address: "住所" },
        services: { title: "3. 提供サービス", intro: "{company}は以下のサービスを提供します：", items: ["専門AIエージェント", "カスタムビジネスアプリケーション（Prime Evolution）", "ドキュメントAIソリューション", "VEECTORIA Pulse - 文字起こしプラットフォーム", "AIコンサルティングと統合"] },
        quotes: { title: "4. 見積もりと注文", content: "すべてのサービスは詳細な見積もりに基づきます。" },
        pricing: { title: "5. 価格と支払い", content1: "価格は税抜きユーロ表示。VAT 20%。30日以内に支払い。", content2: "遅延の場合、遅延利息が適用されます。" },
        delivery: { title: "6. 納品と期限", content: "納期は目安です。{company}は合意した期限の遵守に努めます。" },
        intellectual: { title: "7. 知的財産", content: "開発物は全額支払いまで{company}の所有物のままです。" },
        confidentiality: { title: "8. 機密保持", content: "両当事者は契約終了後3年間機密保持を約束します。" },
        liability: { title: "9. 責任の制限", content: "{company}の責任は契約額に限定されます。" },
        law: { title: "10. 適用法", content: "フランス法が適用されます。管轄裁判所はパリです。" },
      },
    },
    cookiesPolicy: {
      title: "Cookieポリシー",
      sections: {
        what: { title: "1. Cookieとは？", content: "Cookieは、ウェブサイトを訪問した際にデバイスに配置される小さなテキストファイルです。" },
        types: { title: "2. 使用するCookie", intro: "当サイトでは以下のCookieを使用しています：", essential: "必須Cookie", essentialDesc: "サイトの動作に必要です。", analytics: "分析Cookie", analyticsDesc: "使用状況の理解に役立ちます。", preferences: "設定Cookie", preferencesDesc: "選択を記憶します。" },
        retention: { title: "3. 保持期間", content: "Cookieは最大13ヶ月間保持されます。" },
        management: { title: "4. Cookie管理", intro: "いつでも設定を変更できます：", items: ["Chrome：設定 → プライバシー → Cookie", "Firefox：オプション → プライバシー → Cookie", "Safari：設定 → プライバシー → Cookie", "Edge：設定 → Cookie"] },
        contact: { title: "5. お問い合わせ", content: "Cookieに関するご質問はお問い合わせください：" },
      },
    },
  },
};
